export enum AppointmentType {
  Virtual = "Virtual",
  WalkIn = "WalkIn",
  HomeService = "HomeService",
}
